import "./styles.scss";

import CardCreateSigners from "components/card-send-create/card-create-signers";
import CardSendControlCenter from "components/ui/card-send-control-center-dialog/card-send-control-center";
import Dialog from "components/ui/dialog";
import { BaIconChevronLeft } from "components/ui/icons";
import { useApp } from "hooks/app";
import PropTypes from "prop-types";
import React, { useState } from "react";

const CardSendControlCenterDialog = () => {
  const [addMoreSignersToggled, setAddMoreSignersToggled] = useState(false);
  const { cardSendControlCenterOpen, cardSendControlCenter, closeCardSendControlCenter, setCardSendControlCenter, showAlert } = useApp();

  if (!cardSendControlCenter?.cardSend) {
    return null;
  }

  const { location, cardSend, closeAlert, queryParams, onClose, onDelete, withNativeShare } = cardSendControlCenter;
  const inviteSigners = cardSend.signers?.filter((s) => s.inviteEmail) || [];

  const onCloseControlCenter = () => {
    if (closeAlert) {
      showAlert(closeAlert);
    }
    closeCardSendControlCenter();
    onClose && onClose();
  };

  const onSignerErrors = (errors) => {
    if (errors?.length > 0) {
      showAlert({ message: errors[0].errorMessage, type: "error" });
      if (errors[0].errorCode === "already_sent") {
        setCardSendControlCenter({ ...cardSendControlCenter, cardSend: { ...cardSend, sentDttm: true } });
      } else if (errors[0].errorCode === "card_deleted") {
        closeCardSendControlCenter();
      }
    }
  };

  const onRecipientSentByLink = (r) => {
    const newRecipients = cardSend.recipients.map((nr) => (nr.cardSendRecipientId === r.cardSendRecipientId ? { ...nr, sentDttm: true } : nr));
    setCardSendControlCenter({ ...cardSendControlCenter, cardSend: { ...cardSend, recipients: newRecipients } });
  };

  return (
    <Dialog
      open={cardSendControlCenterOpen}
      onClose={onCloseControlCenter}
      className="card-send-control-center-dialog"
      sx={{
        ".MuiDialogContent-root": {
          padding: 0,
        },
      }}
    >
      <div className={`card-send-control-center-signers ${addMoreSignersToggled ? "" : "hidden"}`}>
        <CardCreateSigners
          className="card-send-control-center-signers-contents"
          header={
            <div className="card-send-control-center-signers-header">
              <button className="card-send-control-center-signers-header-back" onClick={() => setAddMoreSignersToggled(false)}>
                <BaIconChevronLeft /> BACK
              </button>
              {inviteSigners.length > 0 ? (
                <h3 className="card-send-control-center-signers-header-title">You added {inviteSigners.length} signers so far, add more!</h3>
              ) : (
                <h3 className="card-send-control-center-signers-header-title">Invite others to join the fun and sign the card!</h3>
              )}
            </div>
          }
          cardSend={cardSend}
          onChange={(result) => setCardSendControlCenter({ ...cardSendControlCenter, cardSend: result })}
          onErrors={onSignerErrors}
        />
      </div>
      <CardSendControlCenter
        location={location}
        cardSend={cardSend}
        queryParams={queryParams}
        onDelete={onDelete}
        onRecipientSentByLink={onRecipientSentByLink}
        onClose={onCloseControlCenter}
        withNativeShare={withNativeShare}
        onSignersClick={() => setAddMoreSignersToggled(true)}
      />
    </Dialog>
  );
};

CardSendControlCenterDialog.propTypes = {
  className: PropTypes.string,
};

CardSendControlCenterDialog.defaultProps = {
  className: "",
};

export default CardSendControlCenterDialog;
